
export default {
  getters: {
    isInitalized(state, getters) {
      return getters.userInitialized && getters.eventsInitialized;
    },
  },
};
